"use client";

import useIsMobile from "@/hooks/use-is-mobile";
import { useSidebarStore } from "@/stores/sidebar-store";
import { Breadcrumbs } from "@/components/layout/breadcrumbs";
import { Icon } from "@/components/ui/icon";
import { UserMenu } from "./user-menu";
import { SearchMenu } from "./search-menu";

/**
 * Top bar. Project switching, credits and the account menu (with the
 * organization picker) live in the sidebar on desktop; on mobile they're
 * reachable from the account sheet, so the navbar stays to breadcrumbs
 * (+ account on mobile). `SearchMenu` only mounts the ⌘K palette.
 */
export function Navbar() {
  const setOpenMobile = useSidebarStore((s) => s.setOpenMobile);
  const isMobile = useIsMobile();

  return (
    <header className="sticky top-0 z-40 flex h-[43px] shrink-0 items-center justify-between gap-2 border-b border-border bg-surface-header dark:bg-surface-primary lg:bg-surface-primary px-4 lg:px-page">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <button
          type="button"
          onClick={() => setOpenMobile(true)}
          className="flex size-8 shrink-0 items-center justify-center rounded-md text-heading hover:bg-contrast/6 transition-colors cursor-pointer lg:hidden"
          aria-label="Open sidebar"
        >
          <Icon name="IconBarsThree" size={20} className="text-heading" />
        </button>
        <Breadcrumbs />
      </div>

      <div className="flex min-w-0 items-center gap-2 lg:gap-3">
        <SearchMenu />
        {isMobile && <UserMenu />}
      </div>
    </header>
  );
}
